<div class="admin-container">
  <h2>Info</h2>
  <form class="form">
    <div class="input-group">
      <label>Titre</label>
      <input type="text" [(ngModel)]="sectionData.title" name="title" />
    </div>
    <div class="input-group">
      <label>Contenu</label>
      <app-text-editor
        [(ngModel)]="sectionData.text"
        [name]="sectionData.id + 'info'"
      ></app-text-editor>
    </div>
  </form>
</div>
